export const mediaTypes = [
  "online media",
  "journalist",
  "blogger",
];
